/* MERCADO 2.0 header (foundation agent) — Modern Beauty Pop.
   Navigation drawer <mc2-nav>, desktop mega panel, the chip rail that folds under rows 1–2 while scrolling down
   (phones only), sticky offsets for other sticky bars, and the bridge that sends every legacy
   "open cart" path to the MC2 drawer. Vanilla JS, no jQuery. Markup: sections/mc2-header.liquid. */
(function () {
  'use strict';
  if (window.MC2 && window.MC2.header) return;
  var MC2 = (window.MC2 = window.MC2 || {});
  var doc = document, html = doc.documentElement;
  var mm = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false, addEventListener: null }; };
  var reduce = mm('(prefers-reduced-motion: reduce)');
  var desktop = mm('(min-width: 990px)');
  var canHover = mm('(hover: hover) and (pointer: fine)');
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function focusables(root) { return $$(FOCUSABLE, root).filter(function (el) { return visible(el) && !el.closest('[hidden]'); }); }
  function focusNoScroll(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }

  /* ---------------- navigation drawer ---------------- */
  var navOpener = null;
  class Mc2Nav extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.panel = $('[data-mc2-nav-panel]', this);
      this.addEventListener('click', (e) => {
        var t = e.target.closest && e.target.closest('[data-mc2-nav-close]');
        if (t) { e.preventDefault(); this.close(); }
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); this.close(); return; }
        if (e.key !== 'Tab') return;
        var f = focusables(this.panel);
        if (!f.length) { e.preventDefault(); this.panel.focus(); return; }
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (doc.activeElement === first || doc.activeElement === this.panel)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    get isOpen() { return !this.hidden; }
    open(opener) {
      if (this.isOpen) return;
      navOpener = opener || doc.activeElement;
      this.hidden = false;
      html.classList.add('mc2-scroll-lock');
      setExpanded(true, 'nav');
      void this.offsetWidth; /* commit the closed state so the slide-in transitions */
      this.classList.add('is-open');
      var target = $('[data-mc2-autofocus]', this) || this.panel;
      setTimeout(function () { focusNoScroll(target); }, reduce.matches ? 0 : 60);
      doc.dispatchEvent(new CustomEvent('mc2:nav:opened'));
    }
    close() {
      if (!this.isOpen) return;
      this.classList.remove('is-open');
      html.classList.remove('mc2-scroll-lock');
      setExpanded(false, 'nav');
      var done = () => { if (!this.classList.contains('is-open')) this.hidden = true; };
      if (reduce.matches) done(); else setTimeout(done, 280);
      if (navOpener && navOpener.focus) focusNoScroll(navOpener);
      navOpener = null;
      doc.dispatchEvent(new CustomEvent('mc2:nav:closed'));
    }
  }
  if (!customElements.get('mc2-nav')) customElements.define('mc2-nav', Mc2Nav);

  function nav() { return $('mc2-nav'); }
  function menuBtn() { return $('[data-mc2-menu]'); }
  function mega() { return $('[data-mc2-mega]'); }
  function header() { return $('[data-mc2-header]'); }
  function setExpanded(open, which) {
    var b = menuBtn();
    if (!b) return;
    b.setAttribute('aria-controls', which === 'mega' ? 'mc2-mega' : 'mc2-nav');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ---------------- desktop mega panel ---------------- */
  var megaTimer = null, megaBy = '';
  function megaOpen() { var m = mega(); return !!(m && !m.hidden); }
  function openMega(focusFirst) {
    var m = mega();
    if (!m) return;
    clearTimeout(megaTimer);
    if (m.hidden) { m.hidden = false; megaBy = focusFirst === 'hover' ? 'hover' : 'click'; setExpanded(true, 'mega'); }
    if (focusFirst === true) { var f = focusables(m)[0]; if (f) f.focus(); }
  }
  function closeMega(returnFocus) {
    var m = mega();
    clearTimeout(megaTimer);
    if (!m || m.hidden) return;
    m.hidden = true;
    megaBy = '';
    setExpanded(false, 'mega');
    if (returnFocus && menuBtn()) menuBtn().focus();
  }

  /* ---------------- search (always visible) ---------------- */
  function searchInput() { return $('[data-mc2-search-input]'); }
  function openSearch() { closeMega(false); setCondensed(false); focusNoScroll(searchInput()); }
  function closeSearch(returnFocus) {
    var ps = $('[data-mc2-search] predictive-search[open]');
    if (ps && typeof ps.close === 'function') ps.close();
    if (!returnFocus) { var i = searchInput(); if (i && doc.activeElement === i) i.blur(); }
  }

  /* ---------------- sticky: the chip rail folds while scrolling down (phones), rows 1–2 stay ---------------- */
  var wrap = null, lastY = 0, ticking = false, condensed = false;
  function headerWrap() {
    var h = header();
    return h ? (h.closest('.shopify-section') || h.parentElement) : null;
  }
  function mainRow() { return $('[data-mc2-header-main]'); }
  /* the rail can be switched off by CSS (product pages on phones, review E-10): offsetHeight then already
     excludes it, and the fold logic below stays idle, so --mc2-sticky-top is always the real visible height */
  function railShown() { var r = $('[data-mc2-hnav]'); return !!(r && visible(r)); }
  function visibleHeight() {
    if (!wrap) return 0;
    var m = mainRow();
    return condensed && m && railShown() ? m.offsetHeight : wrap.offsetHeight;
  }
  function setHeights() {
    if (!wrap) return;
    var m = mainRow();
    html.style.setProperty('--mc2-header-h', wrap.offsetHeight + 'px');
    if (m) html.style.setProperty('--mc2-bar-h', m.offsetHeight + 'px');
    html.style.setProperty('--height-header', wrap.offsetHeight + 'px'); /* legacy theme var (was set by the old header JS) */
    syncStickyTop();
  }
  /* sticky toolbars (collection, brands) sit right under the visible part of the header */
  function syncStickyTop() {
    if (!wrap) return;
    html.style.setProperty('--mc2-sticky-top', visibleHeight() + 'px');
  }
  function setCondensed(on) {
    var h = header();
    if (!h || on === condensed) return;
    condensed = on;
    h.classList.toggle('is-condensed', on);
    syncStickyTop();
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      var h = header();
      if (!wrap || !h) return;
      var y = window.pageYOffset || html.scrollTop || 0;
      var allow = h.getAttribute('data-collapse') === 'true' && h.classList.contains('has-rail') && !desktop.matches && railShown();
      var ae = doc.activeElement;
      var inRail = ae && ae.closest && ae.closest('[data-mc2-hnav]');
      if (!allow || inRail || (nav() && nav().isOpen)) setCondensed(false);
      else if (y < wrap.offsetHeight + 24) setCondensed(false);
      else if (y > lastY + 6) setCondensed(true);
      else if (y < lastY - 6) setCondensed(false);
      wrap.classList.toggle('is-scrolled', y > 4);
      lastY = y;
    });
  }
  /* the selected chip (current page) is brought into view inside the rail without moving the page */
  function revealCurrentChip() {
    var list = $('[data-mc2-hnav-list]');
    var cur = list && $('[aria-current="page"]', list);
    if (!list || !cur || desktop.matches) return;
    var lr = list.getBoundingClientRect(), cr = cur.getBoundingClientRect();
    if (cr.left >= lr.left && cr.right <= lr.right) return;
    var rtl = getComputedStyle(list).direction === 'rtl';
    var delta = rtl ? (cr.right - lr.right + 16) : (cr.left - lr.left - 16);
    list.scrollLeft += delta;
  }

  /* ---------------- legacy cart bridge ----------------
     The legacy Lushy mini cart is no longer rendered. layout/theme.liquid keeps an inert stub
     <span class="js-mini-cart" data-cartmini="true" hidden> so theme.js keeps its "drawer" mode (no cross-sell
     popup / alerts after legacy adds). theme.js marks the stub .active after every cart write it makes
     (theme.miniCart.updateElements): we clear the class, refresh the MC2 drawer from the server and open it. */
  function bridgeLegacyCart() {
    var stub = $('[data-mc2-legacy-cart]');
    if (stub && window.MutationObserver && !stub._mc2) {
      stub._mc2 = true;
      new MutationObserver(function () {
        if (!stub.classList.contains('active')) return;
        stub.classList.remove('active');
        if (!(MC2.cart && MC2.cart.refresh)) return;
        /* never open the drawer over the cart page itself (old theme.js did, see audit T-08) */
        var onCartPage = !!$('[data-mc2-main-cart]') || doc.body.classList.contains('template-cart');
        MC2.cart.refresh().then(function () {
          if (!onCartPage && MC2.cart.open) MC2.cart.open();
        }).catch(function () {});
      }).observe(stub, { attributes: true, attributeFilter: ['class'] });
    }
  }
  /* any leftover legacy trigger (.js-toggle-cart, in third-party or old markup) opens the MC2 drawer instead */
  window.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.js-toggle-cart, [data-toggle="cart-drawer"]') : null;
    if (!t || !(MC2.cart && MC2.cart.open)) return;
    e.preventDefault();
    e.stopPropagation();
    MC2.cart.open();
  }, true);

  /* ---------------- wiring ---------------- */
  var globalsBound = false;
  function init() {
    wrap = headerWrap();
    condensed = false;
    var n = nav();
    if (n && n.parentElement !== doc.body) doc.body.appendChild(n); /* escape the sticky header */

    var b = menuBtn();
    if (b && !b._mc2) {
      b._mc2 = true;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (desktop.matches && mega()) {
          if (!megaOpen()) openMega(false);
          else if (megaBy === 'hover') megaBy = 'click'; /* a click after hover-open pins the panel instead of closing it */
          else closeMega(false);
        }
        else if (nav()) nav().open(b);
      });
      b.addEventListener('keydown', function (e) {
        if (desktop.matches && (e.key === 'ArrowDown') && mega()) { e.preventDefault(); openMega(true); }
      });
      var start = b.closest('.mc2-header__start');
      if (start) {
        start.addEventListener('mouseenter', function () {
          if (!desktop.matches || !canHover.matches) return;
          clearTimeout(megaTimer);
          megaTimer = setTimeout(function () { openMega('hover'); }, 120);
        });
        start.addEventListener('mouseleave', function () {
          if (!desktop.matches || !canHover.matches) return;
          clearTimeout(megaTimer);
          megaTimer = setTimeout(function () { if (megaBy === 'hover' && !start.contains(doc.activeElement)) closeMega(false); }, 300);
        });
        start.addEventListener('focusout', function (e) {
          if (!e.relatedTarget || !start.contains(e.relatedTarget)) setTimeout(function () { if (!start.contains(doc.activeElement)) closeMega(false); }, 0);
        });
        start.addEventListener('keydown', function (e) {
          if ((e.key === 'Escape' || e.key === 'Esc') && megaOpen()) { e.preventDefault(); closeMega(true); }
        });
      }
    }

    var box = $('[data-mc2-search]');
    if (box && !box._mc2) {
      box._mc2 = true;
      box.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        var ps = box.querySelector('predictive-search[open]');
        if (ps && typeof ps.close === 'function') { e.preventDefault(); ps.close(); }
      });
      var form = $('[data-mc2-search-form]', box), input = $('[data-mc2-search-input]', box);
      if (form && input) form.addEventListener('submit', function (e) { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
    }
    var rail = $('[data-mc2-hnav]');
    if (rail && !rail._mc2) {
      rail._mc2 = true;
      rail.addEventListener('focusin', function () { setCondensed(false); });
    }

    if (!globalsBound) {
      globalsBound = true;
      doc.addEventListener('click', function (e) {
        if (!megaOpen()) return;
        var start = menuBtn() && menuBtn().closest('.mc2-header__start');
        if (start && !start.contains(e.target)) closeMega(false);
      });
      if (desktop.addEventListener) desktop.addEventListener('change', function () { closeMega(false); setCondensed(false); if (desktop.matches && nav()) nav().close(); setHeights(); });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', setHeights);
    }

    bridgeLegacyCart();
    setHeights();
    revealCurrentChip();
    lastY = window.pageYOffset || 0;
    if (window.ResizeObserver && wrap && !wrap._mc2ro) { wrap._mc2ro = true; new ResizeObserver(setHeights).observe(wrap); }
  }

  MC2.header = {
    openNav: function () { if (nav()) nav().open(); },
    closeNav: function () { if (nav()) nav().close(); },
    openSearch: openSearch,
    closeSearch: closeSearch
  };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-mc2-header]')) {
      /* the re-rendered section brings its own <mc2-nav>; drop the copy moved to <body> earlier */
      $$('body > mc2-nav').forEach(function (o) { o.remove(); });
      init();
    }
  });
})();
